module.exports = __webpack_public_path__ + "img/耿艳娜.6feeecda.jpg";